import { render, staticRenderFns } from "./VueResponsiveGridLayout.vue?vue&type=template&id=3ffe11c4&"
import script from "./VueResponsiveGridLayout.vue?vue&type=script&lang=ts&"
export * from "./VueResponsiveGridLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports